import { FC } from "react";

interface TranslatedProps {
    isActive?: boolean;
}

export const TranslatedIcon: FC<TranslatedProps> = ({isActive}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.96547e-08 6.9381C6.96547e-08 7.21204 0.17625 7.4556 0.436875 7.54035L3.19125 8.43548L4.08562 11.1885C4.127 11.3156 4.20751 11.4262 4.31562 11.5047C4.42373 11.5832 4.5539 11.6255 4.6875 11.6255C4.8211 11.6255 4.95127 11.5832 5.05938 11.5047C5.16749 11.4262 5.248 11.3156 5.28937 11.1885L6.18562 8.43548L8.93812 7.54035C9.06515 7.49893 9.17582 7.41838 9.25429 7.31024C9.33276 7.2021 9.37502 7.0719 9.375 6.93829C9.375 6.66417 9.19875 6.42098 8.93812 6.33623L6.18562 5.4411L5.28937 2.68804C5.2481 2.56092 5.16763 2.45013 5.0595 2.37156C4.95138 2.29299 4.82116 2.25067 4.6875 2.25067C4.55384 2.25067 4.42362 2.29299 4.3155 2.37156C4.20737 2.45013 4.1269 2.56092 4.08562 2.68804L3.19125 5.4411L0.436875 6.33623C0.30983 6.37757 0.199134 6.45807 0.120654 6.56619C0.0421732 6.67431 -6.26061e-05 6.8045 6.96547e-08 6.9381Z"
        fill= {!isActive ? "#909090" : "#ffffff"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.54375 0.259764C9.51948 0.184364 9.47191 0.118608 9.4079 0.0719616C9.34388 0.025315 9.26671 0.000183105 9.1875 0.000183105C9.10829 0.000183105 9.03112 0.025315 8.9671 0.0719616C8.90309 0.118608 8.85552 0.184364 8.83125 0.259764L8.29125 1.91745L6.63375 2.45651C6.48 2.50676 6.375 2.65076 6.375 2.81314C6.375 2.97551 6.48 3.11951 6.63375 3.16976L8.29125 3.70883L8.83125 5.36651C8.85552 5.44191 8.90309 5.50767 8.9671 5.55432C9.03112 5.60096 9.10829 5.62609 9.1875 5.62609C9.26671 5.62609 9.34388 5.60096 9.4079 5.55432C9.47191 5.50767 9.51948 5.44191 9.54375 5.36651L10.0837 3.70883L11.7412 3.16976C11.895 3.11951 12 2.97551 12 2.81314C12 2.65076 11.895 2.50676 11.7412 2.45651L10.0837 1.91745L9.54375 0.259764Z"
        fill= {!isActive ? "#909090" : "#ffffff"}
      />
    </svg>
  );
};
import { FC } from "react";

interface TranslatedProps {
    isActive?: boolean;
}

export const TranslatedIcon: FC<TranslatedProps> = ({isActive}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.96547e-08 6.9381C6.96547e-08 7.21204 0.17625 7.4556 0.436875 7.54035L3.19125 8.43548L4.08562 11.1885C4.127 11.3156 4.20751 11.4262 4.31562 11.5047C4.42373 11.5832 4.5539 11.6255 4.6875 11.6255C4.8211 11.6255 4.95127 11.5832 5.05938 11.5047C5.16749 11.4262 5.248 11.3156 5.28937 11.1885L6.18562 8.43548L8.93812 7.54035C9.06515 7.49893 9.17582 7.41838 9.25429 7.31024C9.33276 7.2021 9.37502 7.0719 9.375 6.93829C9.375 6.66417 9.19875 6.42098 8.93812 6.33623L6.18562 5.4411L5.28937 2.68804C5.2481 2.56092 5.16763 2.45013 5.0595 2.37156C4.95138 2.29299 4.82116 2.25067 4.6875 2.25067C4.55384 2.25067 4.42362 2.29299 4.3155 2.37156C4.20737 2.45013 4.1269 2.56092 4.08562 2.68804L3.19125 5.4411L0.436875 6.33623C0.30983 6.37757 0.199134 6.45807 0.120654 6.56619C0.0421732 6.67431 -6.26061e-05 6.8045 6.96547e-08 6.9381Z"
        fill= {!isActive ? "#909090" : "#ffffff"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.54375 0.259764C9.51948 0.184364 9.47191 0.118608 9.4079 0.0719616C9.34388 0.025315 9.26671 0.000183105 9.1875 0.000183105C9.10829 0.000183105 9.03112 0.025315 8.9671 0.0719616C8.90309 0.118608 8.85552 0.184364 8.83125 0.259764L8.29125 1.91745L6.63375 2.45651C6.48 2.50676 6.375 2.65076 6.375 2.81314C6.375 2.97551 6.48 3.11951 6.63375 3.16976L8.29125 3.70883L8.83125 5.36651C8.85552 5.44191 8.90309 5.50767 8.9671 5.55432C9.03112 5.60096 9.10829 5.62609 9.1875 5.62609C9.26671 5.62609 9.34388 5.60096 9.4079 5.55432C9.47191 5.50767 9.51948 5.44191 9.54375 5.36651L10.0837 3.70883L11.7412 3.16976C11.895 3.11951 12 2.97551 12 2.81314C12 2.65076 11.895 2.50676 11.7412 2.45651L10.0837 1.91745L9.54375 0.259764Z"
        fill= {!isActive ? "#909090" : "#ffffff"}
      />
    </svg>
  );
};
